<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Contratante</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content> </mat-card-content>

    <form [formGroup]="form" (ngSubmit)="onSave()">
      <div class="row">
        <h4>Dados da Conta</h4>
      </div>

      <div class="row">
        <span class="col-6"
          ><mat-form-field appearance="outline" class="full-width">
            <mat-label>CNPJ</mat-label>
            <input
              matInput
              formControlName="cnpj"
              [specialCharacters]="cnpjSpecialCharacters"
              [mask]="cnpjMask"
            />
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage("cnpj") }}
            </mat-error>
            <mat-error>
              {{ getGroupErrorMessage() }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>CPF</mat-label>
            <input
              matInput
              formControlName="cpf"
              [specialCharacters]="['.', '-']"
              mask="000.000.000-00"
            />
            <mat-error *ngIf="!hasGroupError()">
              {{ getControlErrorMessage("cpf") }}
            </mat-error>
            <mat-error>
              {{ getGroupErrorMessage() }}
            </mat-error>
            <!-- <mat-error *ngIf="fg.get('document')!.hasError('required')">
          Campo obrigatório
        </mat-error> -->
          </mat-form-field></span
        >

        <span class="col-12">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nome Completo</mat-label>
            <input matInput formControlName="name" />
            <mat-error>
              {{ getControlErrorMessage("name") }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-4">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Celular</mat-label>
            <input
              matInput
              formControlName="mobile"
              [specialCharacters]="['(', ')', ' ', '-']"
              mask="(00) 00000-0000"
            />
            <mat-error>
              {{ getControlErrorMessage("mobile") }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-8">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" />
            <mat-error>
              {{ getControlErrorMessage("email") }}
            </mat-error>
          </mat-form-field>
       
        </span>
      </div>

      <div class="row">
        <h4>Endereço</h4>

        <span class="col-3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>CEP</mat-label>
            <div class="cep-input-wrapper">
              <input matInput formControlName="zipCode" mask="00000-000" />
              <mat-spinner
                *ngIf="isLoadingZipCode"
                diameter="20"
                class="input-spiner"
              ></mat-spinner>
            </div>
            <mat-error>
              {{ getControlErrorMessage("zipCode") }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-7">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Logradouro</mat-label>
            <input
              matInput
              formControlName="address"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
            />
            
            <mat-error>
              {{ getControlErrorMessage("address") }}
            </mat-error>
        </mat-form-field>
        </span>

        <span class="col-2">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Numero</mat-label>
            <input
              matInput
              formControlName="addressNumber"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
            />
            <mat-error>
              {{ getControlErrorMessage("addressNumber") }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Bairro</mat-label>
            <input
              matInput
              formControlName="neighborhood"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
            />
            <mat-error>
              {{ getControlErrorMessage("neighborhood") }}
            </mat-error>
          </mat-form-field>
        </span>

        <span class="col-6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Complemento</mat-label>
            <input
              matInput
              formControlName="complement"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
          /></mat-form-field>
        </span>

        <span class="col-4">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cidade</mat-label>
            <input
              matInput
              formControlName="city"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
          /></mat-form-field>
        </span>

        <span class="col-2">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Estado</mat-label>
            <input
              matInput
              formControlName="state"
              matTooltipPosition="above"
              matTooltipShowDelay="0"
          /></mat-form-field>
        </span>
      </div>

      <div class="actions">
        <button mat-button class="btn-green" type="submit" [disabled]="isSaveDisabled">
          <span>Salvar</span>
        </button>
      </div>
    </form>

    <ng-container *ngIf="isLoadingForm">
      <div class="overlay">
        <mat-spinner diameter="60" class="spinner-overlay"> </mat-spinner>
        <span>
          {{ loadingFormMessage }}, aguarde um momento
          <span class="ellipsis"></span>
        </span>
      </div>
    </ng-container>
  </mat-card>
</app-ui-main-menu>
